import { Cost } from '@r1-frontend/ui-react/components/costs';
import { H4 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph3 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import { TwoInRow } from '~/src/features/tariffBuilder/styled';
import * as ST from './styled';

interface IProps {
    total: number,
    discountValue: number,
}

const TotalInfo = ({ total, discountValue }: IProps): JSX.Element => {
    return (
        <TwoInRow>
            <H4 $inline={true} $withIndent={false}>Итого:</H4>
            <ST.PriceWrap $size={8} $wrap='nowrap'>
                {!!discountValue &&
                    <Paragraph3
                        $inline={true}
                        $withIndent={false}
                        as={Cost}
                        isPreviously={true}
                        $color={COLORS.TextHint}
                    >
                        {total + discountValue}
                    </Paragraph3>
                }
                <H4 $inline={true} $withIndent={false} as={Cost}>{total}</H4>
            </ST.PriceWrap>
        </TwoInRow>
    );
};

export default TotalInfo;
